import React, { useState } from 'react';
import { NavbarProps } from '../types';

const Navbar: React.FC<NavbarProps> = ({ currentPage, setCurrentPage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const handlePageChange = (page: string): void => {
    setCurrentPage(page);
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <button 
          className="navbar-brand"
          onClick={() => handlePageChange('home')}
        >
          Postresitos & Café
        </button>
        
        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <button 
            className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
            onClick={() => handlePageChange('home')}
          >
            Inicio
          </button>
          <button 
            className={`nav-link ${currentPage === 'productos' ? 'active' : ''}`}
            onClick={() => handlePageChange('productos')}
          >
            Productos
          </button>
          <button 
            className={`nav-link ${currentPage === 'contacto' ? 'active' : ''}`}
            onClick={() => handlePageChange('contacto')}
          >
            Contacto
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;